import { PageGeneric } from "../PageGeneric/PageGeneric"

export class Home extends PageGeneric{
  render() {
    return(
      <div>
        <h1 className = "px-10 pb-1 text-3xl md:text-5xl">
          Jacob Harmon 
        </h1>
        <h2 className = "px-10 text-base"> Full-stack Software Engineer, Data Analyst </h2>
        <div className="h-12 md:0"/>
        <div className = "mx-8 transform md:translate-y-1/2">
          <p className = "text-base text-center">
            Adding my mastermind game broke my site because the routing is now much more complex. Will fix after I finish mastermind. Test anytime at jacobharmon43.github.io/#/Codecrackr
          </p>
        </div>
        <div className="h-12 md:0"/>
      </div>
    )
  }
};
